import { useRef, useState } from "react"
import stringHelpers from "../../../utilities/stringHelpers"
import arrayUtilities from "../../../utilities/arrayUtilities"
import { Modal } from "react-bootstrap"

export const CashlessProviderCodesInput = ({ allCodes, handleSubmit }) => {
    const [newCode, setNewCode] = useState("")
    const [editIndex, setEditIndex] = useState(null)
    const [showInputModal, setShowInputModal] = useState(false)
    const codeInputRef = useRef(null)
    const codes = stringHelpers.isNullOrEmpty(allCodes)
        ? []
        : allCodes.split(",").map(code => code.trim()).filter(code => !stringHelpers.isNullOrEmpty(code))
    const isEditing = editIndex !== null && editIndex > -1
    const modalTitle = isEditing ? "Edit code" : "Add code"

    const handleEdit = (code, index) => {
        setNewCode(code)
        setEditIndex(index)
        setShowInputModal(true)
    }

    const handleRemove = (index) => {
        const newArray = codes.filter((_, codeIndex) => codeIndex !== index)
        handleSubmit(newArray.join(","))
    }

    const handleModalClose = () => {
        setShowInputModal(false)
        setNewCode("")
        setEditIndex(null)
    }

    const handleSave = (e) => {
        e.preventDefault()
        if (stringHelpers.isNullOrEmpty(newCode)) {
            return
        }
        if (isEditing) {
            const newArray = codes.toSpliced(editIndex, 1, newCode)
            handleSubmit(newArray.join(","))
        } else {
            const newArray = [...codes, newCode]
            handleSubmit(newArray.join(","))
        }
        handleModalClose()
    }
    return (
        <div className="cashless-provider-code row align-items-start" style={{height: arrayUtilities.isNullOrEmpty(codes) && "42px"}}>                
                <div className="col-10 d-flex flex-wrap mb-1">
                    {
                        !arrayUtilities.isNullOrEmpty(codes) && codes.map(
                            (code, index) => <div key={ index } className="mr-3 mt-2 badge badge-pill badge-light border text-secondary position-relative p-0 mw-100">
                                <button type="button" onClick={ () => handleEdit(code, index) } className="btn btn-none btn-sm m-0 d-flex align-items-center px-3">
                                    <p className="text-secondary font-weight-semi-bold fs--1 m-0 text-left" style={ { whiteSpace: "normal", wordBreak: "break-all" } }>{ code }</p>
                                </button>
                                <button onClick={ () => handleRemove(index) } type="button" className="btn btn-secondary rounded-circle shadow-sm d-flex align-items-center justify-content-center position-absolute p-0" style={ { top: "-6px", right: "-8px", width: "18px", height: "18px" } }>
                                    <i className="fas fa-times text-white m-0 p-0" style={ { fontSize: "10px" } }></i>
                                </button>
                            </div>
                        )
                    }
                    <button type="button" onClick={ () => setShowInputModal(true) } className="btn btn-none m-0 mt-1 p-0">
                        <i className="fas fa-plus-circle text-success" style={ { fontSize: "22px" } }></i>
                    </button>
                </div>
            
            {
                showInputModal &&
                <Modal show onHide={ () => handleModalClose() } onEntered={ () => codeInputRef.current?.focus() } centered>
                    <Modal.Header className='d-flex justify-content-between align-items-start'>
                        <Modal.Title className="modal-title"><h5 className="modal-title">{ modalTitle }</h5></Modal.Title>
                        <button onClick={ () => handleModalClose() } type="button" className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <form onSubmit={ (e) => handleSave(e) }>
                        <Modal.Body>
                            <input ref={ codeInputRef } className="form-control shadow-none mb-0 w-100 outline-none" type="text" value={ newCode } onChange={ (e) => setNewCode(e.target.value) } />
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => handleModalClose() }>Cancel</button>
                            <button disabled={ stringHelpers.isNullOrEmpty(newCode) } type="submit" className="btn btn-success btn-sm ml-2">Save</button>
                        </Modal.Footer>
                    </form>
                </Modal>
            }
        </div>
    )
}